<template>
  <div>
    <b-modal :id="`bv-modal-advert-status`" hide-footer>
      <template #modal-title>Advert status</template>

      <div class="text-center">
        <img :src="advert.image" style="height:5rem;" class="rounded">
      </div>

      <div class="bg-white rounded">
        <div class="row">
          <div class="col">
            <label class="form-label">Status</label>
            <select
              class="form-control2"
              v-model="advert.status"
              style="padding: 0.7rem 1.2rem">
              <option
                v-for="(apple, index) in statuses"
                :key="index"
                :value="apple">
                {{ apple }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
          <button
            type="button"
            class="btn btn-secondary submit col"
            @click="hideModalChangeStatus">Cancel</button>
        </div>
        <div class="col">
          <button
            v-if="updating"
            type="button"
            class="btn btn-success submit col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>
          </button>
          <button
            v-else
            type="button"
            class="btn btn-success submit col" @click="saveEmail">Change</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from "../bus";

export default {
  props: ['advert'],

  data() {
    return {
      updating: false,
      loading: false,
      statuses: ['Active', 'Inactive'],
    };
  },

  created() {},

  methods: {
    hideModalChangeStatus() {
      this.$bvModal.hide(`bv-modal-advert-status`);
    },

    successAlert(text) {
      Swal.fire({
        title: text,
        customClass: { title: "popup-title", icon: "custom-icon-size" },
        icon: "success",
        showConfirmButton: false,
        timer: 3000,
      });
    },

    saveEmail() {
      this.updating = true;

      axios
        .post(`/adverts/update-status`, {
          advert_id: this.advert.id,
          status: this.advert.status,
        })
        .then((response) => {
          if (response.data.success) {
            EventBus.$emit("advert-status-updated");
            this.hideModalChangeStatus();
            this.successAlert(response.data.message);
          } else {
            this.sweetfire(response.data.message);
          }

          this.updating = false;
        });
    },

    successAlert(text) {
      Swal.fire({
        title: text,
        customClass: { title: "popup-title", icon: "custom-icon-size"},
        icon: "success",
        showConfirmButton: false,
        timer: 3000,
      });
    },

    hideModalChangeStatus() {
      this.$bvModal.hide(`bv-modal-advert-status`);
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: {
          title: "popup-title",
        },
      });
    },

  },
};
</script>

<style scoped>
.advert_image {
  height: 3rem;
}
</style>